"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var gl_resource_1 = __importDefault(require("./gl-utils/gl-resource"));
var fbo_1 = __importDefault(require("./gl-utils/fbo"));
var ObstacleMapShaders = __importStar(require("./shaders/obstacle-map-shaders"));
var ObstacleMap = (function (_super) {
    __extends(ObstacleMap, _super);
    function ObstacleMap(gl, width, height) {
        var _this = _super.call(this, gl) || this;
        _this._width = width;
        _this._height = height;
        _this._fbo = new fbo_1.default(gl, width, height);
        _this._drawShader = ObstacleMapShaders.buildDrawShader(gl);
        _this._addShader = ObstacleMapShaders.buildAddShader(gl);
        _this.initObstaclesMap();
        return _this;
    }
    ObstacleMap.prototype.freeGLResources = function () {
        var gl = _super.prototype.gl.call(this);
        this._fbo.freeGLResources();
        this._fbo = null;
        gl.deleteTexture(this._texture);
        gl.deleteTexture(this._initTexture);
        this._drawShader.freeGLResources();
        this._addShader.freeGLResources();
        this._drawShader = null;
        this._addShader = null;
    };
    Object.defineProperty(ObstacleMap.prototype, "texture", {
        get: function () {
            return this._texture;
        },
        enumerable: false,
        configurable: true
    });
    ObstacleMap.prototype.draw = function () {
        var gl = _super.prototype.gl.call(this);
        var drawShader = this._drawShader;
        drawShader.u["uObstacles"].value = this.texture;
        drawShader.use();
        drawShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    ObstacleMap.prototype.addObstacle = function (pos, size) {
        var gl = _super.prototype.gl.call(this);
        var addShader = this._addShader;
        addShader.u["uSize"].value = pos;
        addShader.u["uPos"].value = size;
        this._fbo.bind([this._texture]);
        addShader.use();
        addShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    ObstacleMap.prototype.initObstaclesMap = function () {
        var gl = _super.prototype.gl.call(this);
        var width = this._width;
        var height = this._height;
        var texels = [];
        for (var iY = 0; iY < height; ++iY) {
            for (var iX = 0; iX < width; ++iX) {
                if (iY === 0) {
                    texels.push.apply(texels, [127, 255, 0, 255]);
                }
                else if (iY === height - 1) {
                    texels.push.apply(texels, [127, 0, 0, 255]);
                }
                else if (iX === 0) {
                    texels.push.apply(texels, [255, 127, 0, 255]);
                }
                else if (iX === width - 1) {
                    texels.push.apply(texels, [0, 127, 0, 255]);
                }
                else {
                    texels.push.apply(texels, [127, 127, 0, 255]);
                }
            }
        }
        var data = new Uint8Array(texels);
        var textures = [];
        for (var i = 0; i < 2; ++i) {
            var tex = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, tex);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            textures.push(tex);
        }
        gl.bindTexture(gl.TEXTURE_2D, null);
        this._texture = textures[0];
        this._initTexture = textures[1];
    };
    return ObstacleMap;
}(gl_resource_1.default));
exports.default = ObstacleMap;
